<template>
  <div class="properties">
    <!-- <h2 class="properties__title">{{ $tc('residentialProperties', 2) }}</h2> -->
    <div class="properties__items">
      <div class="properties__item" v-for="(property, index) in items" :key="property.key + index">
        <div class="properties__item-label">
          {{ property.label || $tc(property.key) }}
        </div>
        <div class="properties__item-value">{{ property.formatted }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('Residential', ['item']),
    items() {
      return (this.$path('item.properties') || []).filter(p => p.formatted)
    },
  },
}
</script>

<style lang="scss">
.properties {
  &__title {
    margin-bottom: 1.5rem;
  }

  &__items {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  &__item {
    background-color: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.07);
    padding: 1em;

    &-label {
      opacity: 0.75;
    }

    &-value {
      font-weight: bold;
      font-size: 1.2em;
      margin-top: 0.25em;
    }
  }
}
</style>
